var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"className":"sc-CtfFt efFpcB","key":0},"drover_ui_cross_icon"),React.createElement("g",{"id":"Layer_4","className":"sc-laTMn fJphvA","key":1},[React.createElement("line",{"x1":"34","y1":"34","x2":"6","y2":"6","className":"sc-fjmCvl jmdDbZ","style":{"fill":"none","strokeLinejoin":"round","strokeWidth":"4px"},"key":0}),React.createElement("line",{"x1":"34","y1":"6","x2":"6","y2":"34","className":"sc-fjmCvl jmdDbZ","style":{"fill":"none","strokeLinejoin":"round","strokeWidth":"4px"},"key":1})])]);
}

CloseIcon.defaultProps = {"color":"#ffffff","height":"17px","viewBox":"0 0 40 40","width":"17px","className":"sc-hGoxap irFVct styles__CloseIcon-sc-51od27-2 fagkbJ","stroke":"#ffffff","style":{"cursor":"pointer"}};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
